import * as lottie from 'lottie-web/build/player/lottie';
import { AnimationService } from "../../../helpers/classes/AnimationService";
import EventService from "../../../helpers/classes/EventService";
import { ExceptionManager } from "../../../helpers/classes/ExceptionManager";
import LanguageService from "../../../helpers/classes/LanguageService";
import RenderingService from "../../../helpers/classes/RenderingService";
import TemplateService from "../../../helpers/classes/TemplateService";
import { JourneyContainer } from "../../classes/JourneyContainer";
import { JourneyEvent } from "../../enums/JourneyEvent";
import { Templates } from "../../enums/Templates";
import { TranslationKey } from "../../enums/Translation";

export class DataChecksStep {

	public static render(this: JourneyContainer) {
		return TemplateService.renderToContainer(this._container, Templates.DataChecks)
			.then((element) => TemplateService.getElements(element, {
				form: '[data-jcs-element="user__input__form"]',
				houseNumber: '[data-jcs-element="user__input__house__name__number"]',
				streetName: '[data-jcs-element="user__input__street__name"]',
				town: '[data-jcs-element="user__input__town"]',
				postalCode: '[data-jcs-element="user__input__postal__code"]',
				errors: '[data-jcs-element="user__input__errors"]',
				submit: '[data-jcs-element="user__input__submit"]',
				loadingAnimationContainer: '[data-jcs-element="loading-animation"]'
			}))
			.then(({ form, houseNumber, streetName, town, postalCode, errors, submit, loadingAnimationContainer }) => {
				if (form instanceof HTMLFormElement &&
					houseNumber instanceof HTMLInputElement &&
					streetName instanceof HTMLInputElement &&
					town instanceof HTMLInputElement &&
					postalCode instanceof HTMLInputElement &&
					submit instanceof HTMLInputElement) {

					if (this._journey) {
						RenderingService.setValue(town, this._journey.information.holder.address.city);
						RenderingService.setValue(postalCode, this._journey.information.holder.address.postCode);
					}

					form.addEventListener('submit', async (e) => {
						e.preventDefault();
						RenderingService.setText(errors);

						DataChecksStep.validateInputs(houseNumber, streetName, town, postalCode)
							.catch(DataChecksStep.renderErrors.bind(this))
							.then((validationResult) => { RenderingService.setEnabled(submit, true); return validationResult })
							.then(async (validationResult) => {
								if (validationResult) {
									DataChecksStep.loadingAnimation = AnimationService.CreateAnimation(loadingAnimationContainer as HTMLDivElement, this.assetsFolder + '/animations/loading.json', true, true, {});
									RenderingService.showObject(loadingAnimationContainer);
									RenderingService.setEnabled(submit, false);
									await this._journey?.continueDataChecks({
										journeyId: this._journey!.id,
										houseName: houseNumber.value,
										streetName: streetName.value,
										town: town.value,
										postCode: postalCode.value
									}).then(() => this.evaluate());
								}
							})
					});

					return Promise.resolve();
				} else {
					return Promise.reject(new ExceptionManager.TemplateException(TranslationKey.EXCEPTION_TEMPLATE_ELEMENTS_MISSING));
				}
			})
			.then(() => EventService.publish(JourneyEvent.DISPLAY_STEP, { step: Templates.DataChecks }));
	}

	private static validateInputs = (houseNumber: HTMLInputElement, streetName: HTMLInputElement, town: HTMLInputElement, postalCode: HTMLInputElement): Promise<boolean> => new Promise((resolve, reject) => {
		var validationResult = true;

		if (!houseNumber.value) {
			RenderingService.addClass(houseNumber, "input_failure");
			validationResult = false;
		} else
			RenderingService.removeClass(houseNumber, "input_failure");

		if (!streetName.value) {
			RenderingService.addClass(streetName, "input_failure");
			validationResult = false;
		} else
			RenderingService.removeClass(streetName, "input_failure");

		if (!town.value) {
			RenderingService.addClass(town, "input_failure");
			validationResult = false;
		} else
			RenderingService.removeClass(town, "input_failure");

		if (!postalCode.value) {
			RenderingService.addClass(postalCode, "input_failure");
			validationResult = false;
		} else
			RenderingService.removeClass(postalCode, "input_failure");

		if (!validationResult) {
			return reject(ExceptionManager.process(new ExceptionManager.MissingParameterException(TranslationKey.EXCEPTION_MISSING_REQUIRED_FIELD_MISSING)));
		} else {
			
			if (postalCode.value.length < 5 || postalCode.value.length > 8 || postalCode.value.trim().length===0) {
				RenderingService.addClass(postalCode, "input_failure");
				return reject(ExceptionManager.process(new ExceptionManager.MissingParameterException(TranslationKey.EXCEPTION_POSTCODE_FORMAT_ERROR)));
			}
			if (houseNumber.value.length < 1 || houseNumber.value.trim().length===0) {
				RenderingService.addClass(houseNumber, "input_failure");
				return reject(ExceptionManager.process(new ExceptionManager.MissingParameterException(TranslationKey.EXCEPTION_HOUSENUMBER_FORMAT_ERROR)));
			}
			if (streetName.value.length < 1 || streetName.value.length > 30 ||streetName.value.trim().length===0) {
				RenderingService.addClass(streetName, "input_failure");
				return reject(ExceptionManager.process(new ExceptionManager.MissingParameterException(TranslationKey.EXCEPTION_STREETNAME_FORMAT_ERROR)));
			}
			if (town.value.length < 1 ||town.value.length > 20  ||town.value.trim().length===0) {
				RenderingService.addClass(town, "input_failure");
				return reject(ExceptionManager.process(new ExceptionManager.MissingParameterException(TranslationKey.EXCEPTION_TOWN_FORMAT_ERROR)));
			}
			
			else
				return resolve(validationResult);
		}
	})

	private static renderErrors(this: JourneyContainer, error: ExceptionManager.Exception) {
		TemplateService.getElements(this._container, {
			errors: '[data-jcs-element="user__input__errors"]',
		}).then(({ errors }) => {
			RenderingService.setText(errors, LanguageService.getTranslation(error.message as TranslationKey));
		});
	}

	private static loadingAnimation: lottie.AnimationItem;
}